import type { FC } from "react";

import { Controller, useFormContext } from "@ui/components/Form";
import { TextInput } from "@ui/components/Inputs";
import { useTranslations } from "@ui/providers/useTranslations";

type CountryFieldProps = {
  fieldName: (name: string) => string;
  defaultValue?: string;
};

const COUNTRY_NAME = "countryName";

export const CountryField: FC<CountryFieldProps> = ({ fieldName, defaultValue }) => {
  const { __ } = useTranslations();
  const { control } = useFormContext();

  const preparedFieldName = fieldName(COUNTRY_NAME);

  return (
    <Controller
      name={preparedFieldName}
      control={control}
      render={({ field }) => (
        <TextInput
          {...field}
          id={__("address_fields.country")}
          readOnly={true}
          required={true}
          defaultValue={defaultValue}
          label={__("address_fields.country")}
          data-testid={`${preparedFieldName}-input`}
          placeholder={__("address_fields.country_placeholder")}
          autoComplete="country-name"
        />
      )}
    />
  );
};
